export const TABLE_NAME_JA = {
  projectName: 'プロジェクト名',
  fileName: 'ファイル名',
  statusLabel: '状態',
  completedDateTime: '完了日時'
} as const

export const FIELDS_TYPED = Object.entries(TABLE_NAME_JA).map(([key, label]) => {
  return { key: key, label: label }
})
